import { Answer, Idea } from '@frontend/data-access';
import { Collapse } from 'antd';
import useTranslation from 'next-translate/useTranslation';

function IdeaQuestionnaire({
  idea,
  printMode,
}: {
  idea: Idea;
  printMode?: boolean;
}) {
  const { t: tcommon } = useTranslation('common');
  const Questionnaire = ({ data }: { data?: Answer[] }) => {
    if (data !== undefined && data?.length) {
      if (printMode) {
        return (
          <div className="space-y-2">
            {data.map((item, index) => (
              <div key={index}>
                <div className="text-gray-900 text-sm font-semibold">
                  {item.questionText}
                </div>
                <div className="text-gray-700 text-sm font-normal">
                  {item.text}
                </div>
              </div>
            ))}
          </div>
        );
      } else {
        return (
          <Collapse accordion>
            {data.map((item, index) => (
              <Collapse.Panel header={item.questionText} key={index}>
                {item.text}
              </Collapse.Panel>
            ))}
          </Collapse>
        );
      }
    } else {
      return null;
    }
  };

  return (
    <div>
      {idea?.answers && idea?.answers?.length > 0 && (
        <div className="space-y-2">
          <div className="text-gray-700 text-sm font-normal">
            {tcommon('application_questionnaire')}
          </div>
          <Questionnaire data={idea?.answers} />
        </div>
      )}
    </div>
  );
}

export default IdeaQuestionnaire;
